const Module4Config = {
  day1: {
    learn: {
      video: 'aa28d99e9ac5541703810716027f/480.m3u8',
      song: 'appfiles/posture/school_photo_montage_music_1.m4a',
      json: 'appfiles/posture/school_photo_montage_data_1.json',
    },
    celebrate: {
      video: '554f647e603866a5eac87ec06f8a/480.m3u8',
    },
    rewardOption1: 'Lion',
    rewardOption2: 'Cheetah',
  },
  day2: {
    learn: {
      video: '566220bd710540e91deb84dc6b72/learn_day2.mp4',
      song: 'appfiles/posture/school_photo_montage_music_2.m4a',
      json: 'appfiles/posture/school_photo_montage_data_2.json',
    },
    celebrate: {
      video: '9dd8dfb07a6fc709bdefe59052dd/480.m3u8',
    },
    rewardOption1: 'Parrot',
    rewardOption2: 'Tucan',
  },
  day3: {
    learn: {
      video: 'cc4fd85aa0fbbadddb1db215df72/480.m3u8',
      song: 'appfiles/posture/school_photo_montage_music_3.m4a',
      json: 'appfiles/posture/school_photo_montage_data_3.json',
    },
    celebrate: {
      video: 'Module4Videos/celebrate_day3.mp4',
    },
    rewardOption1: 'JeepBlue',
    rewardOption2: 'JeepPink',
  },
  day4: {
    introVideo: '2e451b2654c34345f34b2fd722f4/480.m3u8',
    rewardOption1: 'Zebras',
    rewardOption2: 'Elephants',
    photoTime: {
      video1: 'a5c7857a1fe581ecdb549a7ec81c/480.m3u8',
      video2: '1ee4e0f07864465da07b471763e6/480.m3u8',
      video3: 'dec332309bc5794bee9ba8033a32/480.m3u8',
    },
    singingTime: {
      intro: '6c6a2e269377b4a6e071b206af45/480.m3u8',
      demoMusic: '',
      singAlongMusic: 'appfiles/posture/posture_student_singalong.m4a',
      instrumentalMusic: 'appfiles/posture/posture_student_instrumental.m4a',
      singingAlongVideo: 'appfiles/posture/singingtime_posture_demo.mp4',
      instrumentalVideo: 'appfiles/posture/singingtime_posture_karaoke.mp4',
    },
  },
  day5: {
    introVideo: 'd39c326c90b5d61eaeabf4db1398/480.m3u8',
    rewardOption1: 'DrumPink',
    rewardOption2: 'DrumBlue',
    learn: {
      recording: 'userfiles/{student-id}/posture_play_day_music.m4a',
      video: 'influencers/{influencer-id}/respond_affirmation.mp4',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      demoSong: 'appfiles/posture/posture_student_singalong.m4a',
      json: 'appfiles/posture/school_photo_montage_data_5.json',
    },
    celebrate: {
      video: '0e8914dada223815ca5d514c1b66/480.m3u8',
      afterVideo: 'c63099cdc2e825c85db4283b20ea/480.m3u8',
      animal: true,
      text: 'Record yourself in an excited voice and say, "I can do it all!"',
      name: 'posture_celebration_surprise_5.mp4',
    },
  },
  day6: {
    rewardOption1: 'Hippo',
    rewardOption2: 'Flamingos',
    learn: {
      recording: 'userfiles/{student-id}/posture_play_day_music.m4a',
      video: 'influencers/{influencer-id}/respond_affirmation.mp4',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      demoSong: 'appfiles/posture/posture_student_singalong.m4a',
      json: 'appfiles/posture/school_photo_montage_data_6.json',
    },
    celebrate: {
      video: '89d9cc41eb827f116b1559d104b4/480.m3u8',
      afterVideo: 'b21d1276fccedd95ab9d571ebfcb/480.m3u8',
      animal: true,
      text: 'Record yourself in a funny voice and say, "I can do it all!"',
      name: 'posture_celebration_surprise_6.mp4',
    },
  },
  day7: {
    rewardOption1: 'Camera',
    rewardOption2: 'Binoculars',
    learn: {
      recording: 'userfiles/{student-id}/posture_play_day_music.m4a',
      video: 'influencers/{influencer-id}/respond_affirmation.mp4',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      demoSong: 'appfiles/posture/posture_student_singalong.m4a',
      json: 'appfiles/posture/school_photo_montage_data_7.json',
    },
    celebrate: {
      video: 'Module4Videos/celebrate_day7.mp4',
      afterVideo: 'e7942b51081cec5f6dbc98ff8a10/480.m3u8',
      animal: true,
      text: 'Record yourself singing, "I can do it all!"',
      name: 'posture_celebration_surprise_7.mp4',
    },
  },
  day8: {
    rewardOption1: 'Ostrich',
    rewardOption2: 'Giraffe',
    learn: {
      recording: 'userfiles/{student-id}/posture_play_day_music.m4a',
      video: 'influencers/{influencer-id}/respond_affirmation.mp4',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      demoSong: 'appfiles/posture/posture_student_singalong.m4a',
      json: 'appfiles/posture/school_photo_montage_data_8.json',
    },
    celebrate: {
      video: '5ff0ab21e60bfbfdaf9d19eae1d3/480.m3u8',
      afterVideo: '8942fd9a65ea597e9347bd9a3c00/480.m3u8',
      animal: true,
      text: 'Record yourself making a silly face and say, "I can do it all!"',
      name: 'posture_celebration_surprise_8.mp4',
    },
  },
  day9: {
    conclusionVideo: 'a741bf58d561a70b5709f02cb73d/480.m3u8',
    rewardOption1: 'Hat',
    rewardOption2: 'Bowtie',
    learn: {
      recording: 'userfiles/{student-id}/posture_play_day_music.m4a',
      video: 'influencers/{influencer-id}/respond_affirmation.mp4',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      demoSong: 'appfiles/posture/posture_student_singalong.m4a',
      json: 'appfiles/posture/school_photo_montage_data_9.json',
    },
    celebrate: {
      video: '8a2393a2c534c898d166d4fcfefb/480.m3u8',
      afterVideo: null,
      animal: true,
      text: 'Record yourself dancing and say, "I can do it all!"',
      name: 'posture_celebration_surprise_9.mp4',
    },
    surprise: {
      video: '2126608e7693c5b6e9688c276a82/480.m3u8',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      slides: [
        'influencers/{influencer-id}/respond_affirmation.mp4',
        'userfiles/{student-id}/posture_celebration_surprise_6.mp4',
        'userfiles/{student-id}/posture_smile.jpg',
        'influencers/{influencer-id}/posture_video_message.mp4',
        'userfiles/{student-id}/posture_celebration_surprise_8.mp4',
        'userfiles/{student-id}/posture_silly_photo_3.jpg',
        'userfiles/{student-id}/posture_celebration_surprise_9.mp4',
      ],
    },
  },
};

export default Module4Config;
